<template>
  <div v-if="category" class="category-header xcontainer">
    <plugin-index action="getPluginsByCategory" :request-data="requestData">
      <template #header>
        <h1>{{ category.title }}</h1>
      </template>
    </plugin-index>
  </div>
</template>

<script setup lang="ts">
  import {useRoute} from 'vue-router';
  import {
    computed,
    definePageMeta,
    useAppStore,
    useAsyncData,
    usePluginIndexStore,
  } from '#imports';
  import {usePluginStoreStore} from '@/stores/plugin-store';

  definePageMeta({
    layout: 'site',
  });

  const route = useRoute();
  const pluginStoreStore = usePluginStoreStore();
  const pluginIndexStore = usePluginIndexStore();
  const appStore = useAppStore();

  const category = computed(() =>
    pluginStoreStore.getCategoryBySlug(route.params.slug),
  );

  const requestData = computed(() => {
    return {
      categoryId: category.value.id,
    };
  });

  await useAsyncData(async () => {
    await pluginIndexStore
      .getPluginsByCategory({
        categoryId: category.value.id,
      })
      .catch((thrown) => {
        throw createError({message: thrown});
      });

    await appStore.updatePageMeta({
      title: category.value.title,
      description: category.value.description,
    });
  });
</script>
